import script from "./PositionTrackerAndroidButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionTrackerAndroidButton.vue?vue&type=script&setup=true&lang=js"

import "./PositionTrackerAndroidButton.vue?vue&type=style&index=0&id=206c977e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206c977e"]])

export default __exports__